// This file contains our custom toast layout
import { nanoid } from "nanoid"
import { useRef } from "react"
import styled, { css } from "styled-components"
import { Icon } from "~/components"
import type { ToastType } from "~/ur-react-components"

const typeIcons: {
  [key in ToastType]: string
} = {
  success: "circle-check",
  error: "circle-exclamation",
  warning: "circle-exclamation",
  info: "circle-info",
}

interface LayoutProps {
  type: ToastType
  width?: string
}

const Layout = styled.div<LayoutProps>`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 1;

  border: 3px solid;
  border-radius: 1rem;
  padding: 1rem 2rem;
  box-sizing: border-box;

  ${(props) =>
    props.type === "success" &&
    css`
      background-color: ${props.theme.colors.success99};
      border-color: ${props.theme.colors.success90};
    `}

  ${(props) =>
    props.type === "error" &&
    css`
      background-color: ${props.theme.colors.error99};
      border-color: ${props.theme.colors.error80};
      color: ${props.theme.colors.error20};
    `}

  ${(props) =>
    props.type === "warning" &&
    css`
      background-color: ${props.theme.colors.warning95};
      border-color: ${props.theme.colors.warning70};
      color: ${props.theme.colors.warning20};
    `}

  ${(props) =>
    props.type === "info" &&
    css`
      background-color: ${props.theme.colors.primary99};
      border-color: ${props.theme.colors.primary90};
    `}
`

const IconWrapper = styled.div``

const Content = styled.div`
  max-width: 450px;
  font-size: 1.15rem;
`

export interface ToastProps {
  id?: string
  type: ToastType
  message: string

  width?: string
}

const Toast: React.FC<ToastProps> = ({ id: _id, type, message, width }) => {
  const id = useRef(_id ?? nanoid())
  return (
    <Layout type={type} id={id.current}>
      <IconWrapper>
        {/* @ts-ignore */}
        <Icon icon={typeIcons[type]} type="solid" />
      </IconWrapper>
      <Content>{message}</Content>
    </Layout>
  )
}

export default Toast
